module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAAAXNSR0IArs4c6QAAAVlJREFUOBGtVDtOw0AQZdeW7CJdCi5At40lHwBqmlQxLSegIkFwA2QqTkBLUuUGyQEsu9mOC1Cko7AL27xneaVdY4GFstJodt7Me579WZwNhtZ6VpblrRBi0batgp/DH+E1/C4Mwzel1JdNE3ZQFEXSNM0ris9t3J5D7FNKeRdF0cbg0kzyPH+s6/r9NwHWMs861htu1wk7YMKAU73neTfsSHAPqqr6+KuDMWEuLQiCC8lNHAogeQ072ETEe+I2Rh75EomFnejna/ilEaIA4gT2AHMG+RJqykERALuC4+4vYS8wCmyBX8I7g3x2MnfQPqAQbBXH8Qp+DfshwFLy2clxTATJAyzNsiz1fT9lPFZHPjvRw2RP4FK2sHsc/wbHmYwJkc9OdkMRxM8UMEug7+8RcWeQf5p7wsfEt+DITwzI6/is59UF8DSR25Wx3jzCk7xiR4Sf+M//5BtPttGFpYMLcwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lrdelete.png
// module id = 592
// module chunks = 1